import React, { Component } from "react";
import { Link } from "react-router-dom";

class Banner extends Component {
  render() {
    return (
      <div className="sigma_banner light-bg style-10 bg-cover ">
        <img
          src={process.env.PUBLIC_URL + "/assets/FinalImage.png"}
          alt="img"
          className="banner_image"
        />
        <div className="banner-slider-inner">
          <div className="sigma_banner-text">
            <div className="bannerContainer">
              <div className="row align-items-center">
                <div className="col-lg-4 col-md-8 col-sm-12">
                  <h1 className="title text-white">
                    Embrace a Healthier Future now!
                  </h1>
                  <div className="banner-links d-flex">
                    <Link to="/book-an-appointment" className="sigma_btn">
                      Book An Appointment
                    </Link>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default Banner;
